import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/features/auth/context/AuthContext";
export const SouserBulletinGuard = ({ children }: { children: ReactNode }) => {
  const { userData } = useAuth();
  const blocked = userData?.userType?.toLowerCase() === "souser" &&
    !userData.announcements_read && !userData.announcements_write;
  return blocked ? <Navigate to="/chat" replace /> : children;
};
